<template>
  <base-card-v2 class="details-header">
    <!-- header -->
    <div class="details-header-blocks">
      <div>
        <label>{{ $t(path + '.detail.header.name') }}</label>
        <el-tooltip
          :visible="hasSpecialCharactersName"
          :raw-content="true"
          :content="$t('audiences.error-characters-name')"
          placement="right"
          popper-class="el--tooltip-error details-header__input--tooltip"
        >
          <input
            ref="headerDetailsInputBlur"
            class="header-details-input"
            :placeholder="$t(path + '.detail.header.name-add')"
            :value="vuexDetail.name"
            :class="{
              'details-header__input--error': hasSpecialCharactersName,
            }"
            @input="verifySpecialCharacters"
          />
        </el-tooltip>
      </div>
      <div v-if="hasGroup" class="details-group-block">
        <label>Grupo <span>*opcional</span> </label>
        <v-select
          v-model="groupOption"
          label="name"
          :clearable="false"
          :options="groups"
          @option:selected="actionSetGroup"
        >
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes" class="arrow-down"></span>
          </template>
          <template #no-options>
            {{ $t('no-results') }}
          </template>
        </v-select>
      </div>
      <div class="details-description-block">
        <label>{{ $t(path + '.description-title') }}</label>
        <div>
          <span class="description">{{ vuexDetail.description }}</span>
          <a href="#" @click="openEditDescriptionModal">
            {{ vuexDetail.description ? $t('labels-personas.edit') : $t(path + '.detail.header.description-add') }}
          </a>
        </div>
      </div>
    </div>
  </base-card-v2>
</template>

<script>
// libs, helpers, services
import bus from '@/helpers/events/bus';
import vSelect from 'vue-select';
import { getPersonasGroups } from '@/services/personas';
import { mapState, mapActions } from 'vuex';
import { hasInvalidSpecialCharacters } from '@/utilities/validators/verifySpecialCharacters';

export default {
  name: 'HeaderDetails',
  components: {
    vSelect,
  },
  props: {
    hasGroup: {
      type: Boolean,
      default: false,
    },
    path: {
      type: String,
      default: '',
    },
    vuexDetail: {
      type: Object,
      default: () => {},
      required: true,
    },
    actionSetName: {
      type: Function,
      required: true,
    },
    actionSetGroup: {
      type: Function,
      default: () => {},
    },
    editDescriptionEmitter: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {
      groupOption: '',
      groups: [],
    };
  },
  watch: {
    vuexDetail() {
      if (!this.vuexDetail?.groupId) {
        this.groupOption = this.groups[0]?.name;
        return;
      }
      this.groupOption = this.groups[this.vuexDetail?.groupId]?.name;
    },
  },
  mounted() {
    bus.$on('header-details-input-blur', () => {
      this.$refs.headerDetailsInputBlur.focus();
    });

    this.fetchDataGroups();
  },
  beforeUnmount() {
    bus.$off('header-details-input-blur');
  },
  computed: {
    ...mapState('labels', ['hasSpecialCharactersName']),
  },
  methods: {
    ...mapActions('labels', ['setErrorName']),
    verifySpecialCharacters(event) {
      this.actionSetName(event);

      const name = event.target.value;
      const hasError = hasInvalidSpecialCharacters(name);
      this.setErrorName(hasError);
    },
    fetchDataGroups() {
      const emptyGroup = { name: this.$t('personas.none'), id: null };
      getPersonasGroups().then(({ data }) => {
        if (data?.data?.length > 0) {
          this.groups = data.data;
          this.groups.unshift(emptyGroup);
          this.groupOption = this.groups[this.vuexDetail?.groupId]?.name;
        }
      });
    },
    openEditDescriptionModal() {
      bus.$emit(this.editDescriptionEmitter);
    },
  },
};
</script>

<style lang="scss">
.details-header {
  @import '@/assets/scss/vendors/_v-select';

  background: url(~@/assets/img/figures/genericOtoBg.png) no-repeat right 0 center, $color-white;
  height: 128px;
  padding: 25px 40px;

  &__input {
    &--tooltip {
      max-width: 270px !important;
    }

    &--error {
      @include error-inputs;
    }
  }
}
.details-header-blocks {
  display: inline-grid;
  grid-template-columns: 220px 170px auto;
  column-gap: 25px;
  margin-top: 10px;

  .header-details-input {
    width: 216px;
  }

  .details-group-block {
    width: 170px;
  }

  span {
    color: #bbbbbb;
  }
}

.details-description-block {
  font-size: 12.1px;
  color: #888;
  line-height: 20px;
  width: 300px;
  .description {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  a {
    color: $oto-omni;
    text-decoration: underline;
  }
}
</style>
